
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/courier",
      function () {
        return require("private-next-pages/destinations/courier.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/courier"])
      });
    }
  